<template>
  <v-card>
    <v-toolbar>
      <v-toolbar-title>{{story.title}}</v-toolbar-title>
    </v-toolbar>
    <v-list>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Description</v-list-tile-title>
          <v-list-tile-sub-title v-html="story.description"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Owner</v-list-tile-title>
          <v-list-tile-sub-title v-if="story.owner">
            {{story.owner.name}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Sprint</v-list-tile-title>
          <v-list-tile-sub-title v-if="story.sprint">
            {{story.sprint.name}}
          </v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile>
        <v-list-tile-content>
          <v-list-tile-title>Status</v-list-tile-title>
          <v-list-tile-sub-title v-html="story.status"></v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
    <v-card-actions class="pa-3">
      <v-spacer></v-spacer>
      <v-btn :to="{name : 'Show Story', params: {id : story.id}}">
        Show Details
      </v-btn>

    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'StoryCard',
  props: {
    story: Object,
  },
};
</script>
